import { useAuthContext } from "providers/Auth";
import { globalLinks, Links } from "../constants";
import { shouldShowGlobalLink } from "../utils";
import { NavLink } from "./NavLink";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { NotificationsNavLink } from "./NotificationsNavLink";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { useLocation } from "react-router-dom";
import { cx } from "shared/utils/classnames";
import { BetaBadge } from "./BetaBadge";
import { BadgeVariant } from "shared/components";
export const GlobalLinkSection = () => {
  const { Units, Properties, Property } = useUnitsPropertiesDictionary();
  const { type } = useAuthContext();
  const location = useLocation();
  const nameOverrides: Record<string, string> = {
    Units: Units,
    Properties: Properties,
    "Property groups": `${Property} groups`
  };

  if (!type.isBoomScreen && !type.isRentReporting) return;

  return (
    <div className="mb-3 px-4 relative">
      {globalLinks
        .filter(({ name }) => shouldShowGlobalLink(name, type))
        .map(({ to, name, Icon, beta }) => {
          if (name === Links.NOTIFICATIONS)
            return (
              <NotificationsNavLink
                key={"globallinks" + to + name}
                name={name}
                to={to}
                Icon={Icon}
              />
            );

          if (beta)
            return (
              <div key={"globallinks" + to + name}>
                <NavLink to={to} HugeIcon={Icon}>
                  <span className="inline-flex items-center gap-2">
                    <span
                      className={cx(
                        "text-sm font-medium",
                        location.pathname === to
                          ? "text-primary-600"
                          : "text-content-1000"
                      )}
                    >
                      {nameOverrides[name] || name}
                    </span>

                    <BetaBadge
                      className="mix-blend-multiply"
                      variant={
                        location.pathname === to
                          ? BadgeVariant.PRIMARY
                          : BadgeVariant.BASE
                      }
                    />
                  </span>
                </NavLink>
              </div>
            );

          return (
            <NavLink key={"globallinks" + to + name} to={to} HugeIcon={Icon}>
              {nameOverrides[name]}
            </NavLink>
          );
        })}
    </div>
  );
};
